/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type {
  ReactElement,
} from 'react';

import type {
  GroupBase,
  MultiValueRemoveProps,
} from 'react-select';

import styled from 'styled-components';

import { OptionTypeBase } from '../types';

const Wrapper = styled.button<{
  $isDisabled: boolean;
}>(({
  $isDisabled,

  theme: {
    colors,
    select,
  },
}) => ({
  display: 'flex',
  alignItems: 'center',
  color: $isDisabled
    ? colors[select.CLEAR_INDICATOR_COLOR_DISABLED]
    : colors[select.CLEAR_INDICATOR_COLOR],
  background: 'transparent',
  border: 0,
  cursor: 'pointer',
  padding: 0,

  '&:hover': $isDisabled ? undefined : {
    color: colors[select.CLEAR_INDICATOR_COLOR_HOVER],
  },

  '&:active': $isDisabled ? undefined : {
    color: colors[select.CLEAR_INDICATOR_COLOR_ACTIVE],
  },
}));

export function MultiValueRemove<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
Group extends GroupBase<OptionType>,
>({
  selectProps: {
    isDisabled,
  },

  innerProps: {
    className,
    ...innerPropsRest
  },
}: MultiValueRemoveProps<OptionType, IsMulti, Group>): ReactElement {
  return (
    <Wrapper
      {...innerPropsRest as any}
      data-n3-select__multi-value-remove=""
      $isDisabled={isDisabled}
    >
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6663 4.27325L11.7263 3.33325L7.99967 7.05992L4.27301 3.33325L3.33301 4.27325L7.05967 7.99992L3.33301 11.7266L4.27301 12.6666L7.99967 8.93992L11.7263 12.6666L12.6663 11.7266L8.93967 7.99992L12.6663 4.27325Z"
        />
      </svg>
    </Wrapper>
  );
}
